import styled from "styled-components";
import { colors } from "@pepdirect/v3/styles/variables";

export const StyledNote = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius || "10px"};
  background-color: ${({ theme }) =>
    theme.page?.backgroundColor ? colors.white : colors.gray100};
  padding: 10px 20px;
  font-size: 13px;
`;
